import(/* webpackMode: "eager", webpackExports: ["CanonicalUrlCheckerContent"] */ "/vercel/path0/src/app/(general)/free-tools/seo/canonical-url-checker/CanonicalUrlCheckerContent.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CanonicalUrlCheckerTool"] */ "/vercel/path0/src/app/(general)/free-tools/seo/canonical-url-checker/CanonicalUrlCheckerTool.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CtaBanner"] */ "/vercel/path0/src/app/(general)/free-tools/seo/canonical-url-checker/CtaBanner.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Faq"] */ "/vercel/path0/src/components/faq/faq.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/header/header.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustedBy"] */ "/vercel/path0/src/components/trustedBy/trustedBy.comp.tsx");
